import { Injectable } from '@angular/core';
import { Observable, Subject, empty, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
  IUser as IUser, ILoginRequest, User, CreditCardDetails, ICreditInfoBody, IGetItemSuggestionsBody, ItemSuggestion, IUserLogin
  , BaseResponse,
  PWALoginRequest
} from '../models';
import { ConfigService } from './config.service';
import { ApiService } from './api.service';
import { tap, map, catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    private cookieService: CookieService,
    private router: Router) {
    this.init();
  }
  async init() {
    let user = this.readUserObject1();
    if (!user) { user = new User(); }
    if (!user.userLanguage) { user.userLanguage = 'eng'; }
    this.saveUserObject(user);
  }
  //#region UserService Api endPoints
  public validateToken() {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.VALIDATE_TOKEN}`;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint)
  }

  public ChangePassword(data): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.CHANGE_PASSWORD}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
  }
  public changeDefaultPassword(body): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.CHANGE_DEFAULT_PASSWORD}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  public ForgotPassword(body): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.FORGOT_PASSWORD}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  public loadUserDetailsForEdit(userId: any): Observable<any> {
    const apiEndpoint = `${ConfigService.RynoAPIs.endPoints.USER.GET_EDIT_USER_DETAIL}/${userId}`;
    return ApiService.genericObservablerynoGet(this.httpClient, apiEndpoint)
  }

  
  //#region LOGIN & LOGOUT
  public logout() {
    //to unsubscribe from idle session
    try {
      if (this.readUserObject && this.readUserObject.userName != "") {
        this.ToggleIdleSession.next(false);
        this.isUserLoggedIn.next(false); // to show hide footer
        console.log("loggedOut " + this.readUserObject.userName);
        this.deleteRefreshToken().subscribe(response => {
          //this.stopRefreshTokenTimer();
        });
      }
      //this.authService.logout();
    }
    catch (ex) { }
    finally {
      this.stopRefreshTokenTimer();
      this.authService.logout();
    }
    const u = new User();
    u.userLanguage = 'eng';
    this.saveUserObject(u);
    this.router.navigate(['sample-request-admin']);


  }
  public async ConfirmForgotPasswordOtp(body: any) {
    const endPoint = `${ConfigService.APIs.endPoints.USER.CONFIRM_FORGOT_PASSWORD_OTP}`;
    let confirmotpResp;
    await (ApiService.genericObservablePost(this.httpClient, endPoint, body).toPromise()).then((r) => {
      confirmotpResp = r;
    }).catch((e) => {
      if (e.status === 401 || e.status === 403) {
        confirmotpResp = e.error;
      }
    });
    return confirmotpResp;
  }
  public async ForgotPasswordResend(body: any) {
    const endPoint = `${ConfigService.APIs.endPoints.USER.FORGOT_PASSWORD}`;
    let confirmotpResp;
    await (ApiService.genericObservablePost(this.httpClient, endPoint, body).toPromise()).then((r) => {
      confirmotpResp = r;
    }).catch((e) => {
      if (e.status === 401 || e.status === 403) {
        confirmotpResp = e.error;
      }
    });
    return confirmotpResp;
  }

  public async login(login: ILoginRequest) {
    const endPoint = `${ConfigService.APIs.endPoints.USER.LOGIN}`;
    let loginResp;
    await (ApiService.genericObservablePost(this.httpClient, endPoint, login).toPromise()).then((r) => {
      loginResp = r;
    }).catch((e) => {
      if (e.status === 401 || e.status === 403) {
        loginResp = e.error;
      }
    });
    return loginResp;
  }

  public async pwaUserLoginLog(log: PWALoginRequest) {
    const endPoint = `${ConfigService.APIs.endPoints.USER.PWA_LOGIN_LOG}`;
    let logResp;
    await (ApiService.genericObservablePost(this.httpClient, endPoint, log).toPromise()).then((r) => {
      logResp = r;
    }).catch((e) => {
      if (e.status === 401 || e.status === 403) {
        logResp = e.error;
      }
    });
    return logResp;
  }

  public GetOutageObj(): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_OUTAGEOBJ}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, {}).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => {
        return response;
      })

    );
  }
  public async getUserDetails() {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.GET_DETAILS}`;
    let userDetails;
    await (ApiService.genericObservableGet(this.httpClient, apiEndpoint).toPromise()).then(r => {
      if (!r.isError) {
        userDetails = r.data;
      }
    }).catch(e => { });
    return userDetails;
  }

  public logoutUnAuthorized() {

    if (this.readUserObject && this.readUserObject.userName != "") {
      this.ToggleIdleSession.next(false);
      this.isUserLoggedIn.next(false); // to show hide footer
      this.deleteRefreshToken().subscribe(response => {
        this.stopRefreshTokenTimer();
      }, error => { this.stopRefreshTokenTimer(); });
    }
    this.authService.logout();
    const u = new User();
    u.userLanguage = 'eng';
    this.saveUserObject(u);
    this.UnAuthReq.next(true);
    //this.router.navigate(['/unauthorized']);
    this.router.navigate(['/home']);


  }
  //#endregion
  //#region LGGED IN USER 
  public isAuthenticated(): boolean {

    return this.authService.isAuthenticated();
  }
  //#endregion
  //#region USER OBJ/TOKEN IN LOCAL STORAGE
  localStorageUserKey: string = 'aap_user';
  ToggleIdleSession: Subject<boolean> = new Subject<boolean>();

  OutageObject: Subject<any> = new Subject<any>();
  UnAuthReq: Subject<boolean> = new Subject<boolean>();

  LogoutTrigger: Subject<boolean> = new Subject<boolean>();
  public isUserLoggedIn: Subject<boolean> = new Subject<boolean>(); // to show hide footer
  public saveUserObject(login: IUser) {
    //to subscribe to the idle session
    if (login.userName != "") {
      this.ToggleIdleSession.next(true);
      this.isUserLoggedIn.next(true);
      //console.log("userSignedIn " + JSON.stringify(login));
    }

    localStorage.setItem(this.localStorageUserKey, JSON.stringify(login));
  }

  public readUserObject1(): IUser {
    return JSON.parse(localStorage.getItem(this.localStorageUserKey)) as IUser;
  }

  public get readUserObject(): IUser {
    return JSON.parse(localStorage.getItem(this.localStorageUserKey)) as IUser;
  }
  public saveToken(token: string) {
    this.authService.saveToken(token);
    this.startRefreshTokenTimer();
  }
  //#endregion

  //#region role check
  roles = {
    //#Region Product Sample Fulfillment
    INTsampleAdmin: 'INTsampleAdmin',
    //#End Region
  };
  
  
  //#Region Product Sample Fulfillment
  public isSampleProductAdmin() {  
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTsampleAdmin) > -1) return true;
    return false;
  }

  
  //#endregion

  //#region Business Logic UserService Localstorage Methods


  //#endregion
  //#region manage company user accounts access--Need to change condition
  public loggedInAccountType() {
    if (this.readUserObject.isCSCAccount) {
      return "cscAccount";
    } else {
      return "adminAccount";
    }

  }
  //#endregion



  public refresh(): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.USER.GET_NEW_TOKEN}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }
  public deleteRefreshToken(): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.USER.DELETE_REFRESH_TOKEN}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }
  //#region roles

  private handleError(error: any) {
    if (Error instanceof HttpErrorResponse) {
      console.log(error.status);
    }
    else {
      console.error("an error occurred here");
    }
    this.router.navigate(['/error']);
  }
  private refreshTokenTimeout;
  private startRefreshTokenTimer() {
    // set a timeout to refresh the token a minute before it expires
    const expires = this.authService.getTokenExpirationDate();
    const timeout = 20 * 60000; //expires.getTime() - Date.now() - (10 * 60 * 1000);
    this.refreshTokenTimeout = setTimeout(() => this.refresh().subscribe(response => {
      this.saveToken(response.token);
    }), timeout);
  }

  private stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }

  public ForgotUsername(body): Observable<any> {
    const apiEndpoint = `/User/ForgotUsername`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }

}
